<fui-chrome-control-dropdown (onActive)="activeChange($event)" [title]="'wbo.chrome.button.notifications'">
    <fui-icon [height]="15" [icon]="'alert'" [width]="13"></fui-icon>

    <div class="header">
        <div class="header-label">
            <div class="header-label-title" id="label">
                {{"wbo.notification.title" | translate}}
            </div>
        </div>
    </div>
    <div *ngIf="!notifications.length" class="main">
        <div class="no-notifications">
            {{"wbo.notification.empty" | translate}}
        </div>
    </div>
    <div *ngIf="notifications.length" (click)="clickDiv($event)" class="main">
        <div id="entry-{{index}}" *ngFor="let notification of notifications; trackBy: trackByFn; let index = index" class="items">
            <div class="items-content">
                <b *ngIf="!notification.viewed">{{ notification.messageKey | translate:getMessageParams(notification) }}</b>
                <ng-container *ngIf="notification.viewed">{{ notification.messageKey | translate:getMessageParams(notification) }}</ng-container>
                <div>
                    <fui-link-button *ngIf="notification.actionLabelKey" [title]="notification.actionLabelKey | translate"
                                     (click)="handleNotificationAction(notification)"></fui-link-button>
                </div>
                <fui-action class="delete" (click)="deleteNotification($event, notification)">
                    <fui-icon [height]="16" [icon]="'delete'" [width]="16"></fui-icon>
                </fui-action>
            </div>
        </div>
    </div>
</fui-chrome-control-dropdown>
